import { AlertTriangle, ChevronRight, Radio, ShieldAlert } from 'lucide-react';
import { URGENT_ALERTS } from './mockDispatchData';

export default function UrgentAlertsBanner({ alerts = URGENT_ALERTS, onAlertAction, selectedTripId }) {
  const criticalCount = alerts.filter((a) => a.severity === 'critical').length;

  return (
    <section
      aria-label="Urgent action alerts"
      className="overflow-hidden rounded-xl border border-red-200 bg-gradient-to-r from-red-50 via-white to-red-50/80 ring-1 ring-red-500/20"
    >
      <div className="flex flex-wrap items-center gap-3 border-b border-red-500/20 px-4 py-2.5">
        <div className="flex items-center gap-2">
          <div className="flex h-7 w-7 items-center justify-center rounded-lg bg-red-500/20 ring-1 ring-red-500/40">
            <ShieldAlert className="h-4 w-4 text-red-700 animate-pulse" strokeWidth={1.75} />
          </div>
          <div>
            <p className="text-xs font-bold uppercase tracking-widest text-black">
              Urgent Action Required
            </p>
            <p className="text-[10px] text-black/70">
              {criticalCount} critical · {alerts.length} total dispatcher tasks
            </p>
          </div>
        </div>
        <span className="inline-flex items-center gap-1 rounded-full bg-red-500/15 px-2 py-0.5 text-[10px] font-bold uppercase text-black ring-1 ring-red-500/30">
          <Radio className="h-2.5 w-2.5 animate-pulse" />
          Live Ops Feed
        </span>
      </div>

      <div className="divide-y divide-red-500/10">
        {alerts.map((alert) => {
          const isLinked = alert.tripId && alert.tripId === selectedTripId;

          return (
            <div
              key={alert.id}
              className={`flex flex-wrap items-center justify-between gap-3 px-4 py-2.5 transition-colors ${
                isLinked ? 'bg-red-50' : 'hover:bg-red-500/[0.04]'
              }`}
            >
              <div className="flex min-w-0 flex-1 items-start gap-2.5">
                <AlertTriangle
                  className={`mt-0.5 h-4 w-4 flex-shrink-0 ${
                    alert.severity === 'critical' ? 'text-red-700' : 'text-amber-700'
                  }`}
                  strokeWidth={1.75}
                />
                <div className="min-w-0">
                  <p className="text-sm font-medium text-black">{alert.message}</p>
                  {alert.tripId && (
                    <p className="mt-0.5 font-mono text-[10px] text-black/70">{alert.tripId}</p>
                  )}
                </div>
              </div>
              <button
                type="button"
                onClick={() => onAlertAction?.(alert)}
                className="inline-flex flex-shrink-0 items-center gap-1 rounded-lg border border-red-200 bg-red-50 px-3 py-1.5 text-[11px] font-bold uppercase tracking-wide text-black transition hover:bg-red-500/20"
              >
                {alert.action}
                <ChevronRight className="h-3.5 w-3.5" />
              </button>
            </div>
          );
        })}
      </div>
    </section>
  );
}
